import React from 'react'
import { Chart } from 'primereact/chart'
import styles from '../../../css/generals/charts/Doughnut.module.css'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

export default function Doughnuts ({ data, maxWidth, type }) {
  const { t } = useTranslation('home')

  const chartData = {
    labels: type === 'connections' ? [t('boxChart3.label1'), t('boxChart3.label2')] : [t('boxChart4.label1'), t('boxChart4.label2')],
    datasets: [
      {
        data: type === 'connections' ? [data.desconnected, data.connected] : [data.notMissing, data.missing],
        backgroundColor: ['#003686', '#3F9BFF'],
        hoverBackgroundColor: ['#003686', '#3F9BFF']
      }
    ]
  }

  const lightOptions = {
    plugins: {
      legend: {
        labels: {
          color: '#495057'
        }
      }
    }
  }

  return (
    <>
      <div className={`${styles.containerConn}`}>
        <Chart
          type="doughnut"
          data={chartData}
          options={lightOptions}
          style={{
            position: 'relative',
            maxWidth
          }}
          className={`${styles.statConn}`}
        />
      </div>
    </>
  )
}

Doughnuts.propTypes = {
  maxWidth: PropTypes.string,
  data: PropTypes.array,
  type: PropTypes.string
}
